import { render, staticRenderFns } from "./brand.vue?vue&type=template&id=20c28ebe&scoped=true"
import script from "./brand.vue?vue&type=script&lang=js"
export * from "./brand.vue?vue&type=script&lang=js"
import style0 from "./brand.vue?vue&type=style&index=0&id=20c28ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c28ebe",
  null
  
)

export default component.exports